export default "__VITE_ASSET__8893e3d5__"